<div class="icon-action-button-container">
  <p-button
    [icon]="icon"
    [styleClass]="allClasses"
    [pTooltip]="(tooltip && tooltipEnabled) ? tooltip : null"
    [tooltipPosition]="tooltipPosition"
  >
  </p-button>
</div>
